import React from "react";
import { connect } from 'react-redux';
import ReactTable from 'react-table';
import moment from 'moment';
import 'moment-duration-format';
import ZSearch from '../../../../../components/Common/ZSearch';
//import PopupCustomized from '../../../../../components/PopupCustomized';
import { cloneArray, isDefined, sortReactTable, isJibedOnAllQuestions } from '../../../../../utils';
import { agentsFilters } from '../../../../../constants';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import FilterIcon from '../../../../../icons/FilterIcon';
import FilterIconBack from '../../../../../icons/FilterIconBack';
import CloseFilterIcon from '../../../../../icons/CloseFilterIcon';
import MatchingAnswersIcon from '../../../../../icons/MatchingAnswersIcon';
import NotMatchingAnswersIcon from '../../../../../icons/NotMatchingAnswersIcon';
import MatchingAnswersIconNotActive from '../../../../../icons/MatchingAnswersIconNotActive';
import NotMatchingAnswersIconNotActive from '../../../../../icons/NotMatchingAnswersIconNotActive';
import { CalibrationStatus } from '../../../../../generated';

class AgentsTableForSupervisor extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showHelpPopup: false,
            searchAgentNameQuery: undefined,
            selectedAgentFilter: undefined,
            showFiltersHeader: false,

            minDaysSinceLastJibeSessionFilterValue: undefined,
            maxDaysSinceLastJibeSessionFilterValue: undefined,

            showAsatMatchesActive: true,
            showAsatNotMatchesActive: true,
            showResMatchesActive: true,
            showResNotMatchesActive: true,
            showCsatMatchesActive: true,
            showCsatNotMatchesActive: true,
            showNpsMatchesActive: true,
            showNpsNotMatchesActive: true,
        };
        this.onSearchAgent = this.onSearchAgent.bind(this);
        this.onSelectAgentFilter = this.onSelectAgentFilter.bind(this);

        this.showHelpPopup = this.showHelpPopup.bind(this);
        this.closeHelpPopup = this.closeHelpPopup.bind(this);

        this.hideFiltersHeader = this.hideFiltersHeader.bind(this);
        this.showFiltersHeader = this.showFiltersHeader.bind(this);

        this.getTableColumns = this.getTableColumns.bind(this);

        this.getSelectedNode = this.getSelectedFilterValuesNode.bind(this);
        this.getMinMaxFiltersHeader = this.getMinMaxFiltersHeader.bind(this);

        //this.showDaysSinceLastJibeSessionFilterPopup = this.showDaysSinceLastJibeSessionFilterPopup.bind(this);
        //this.hideDaysSinceLastJibeSessionFilterPopup = this.hideDaysSinceLastJibeSessionFilterPopup.bind(this);
        //this.hideDaysSinceLastJibeSessionFiltersHeader = this.hideDaysSinceLastJibeSessionFiltersHeader.bind(this);

        this.changeMatches = this.changeMatches.bind(this);
        this.changeNotMatches = this.changeNotMatches.bind(this);
    }

    showHelpPopup(e) {
        this.setState({ showHelpPopup: true, mouseClickX: e.clientX, mouseClickY: e.clientY });
    }

    closeHelpPopup() {
        this.setState({ showHelpPopup: false });
    }

    changeMatches(shortName) {
        switch (shortName) {
            case 'ASAT':
                this.setState((prevState) => ({
                    showAsatMatchesActive: !prevState.showAsatMatchesActive
                }));
                break;
            case 'RES':
                this.setState((prevState) => ({
                    showResMatchesActive: !prevState.showResMatchesActive
                }));
                break;
            case 'CSAT':
                this.setState((prevState) => ({
                    showCsatMatchesActive: !prevState.showCsatMatchesActive
                }));
                break;
            case 'tNPS':
                this.setState((prevState) => ({
                    showNpsMatchesActive: !prevState.showNpsMatchesActive
                }));
                break;
            default:
        }
    }

    changeNotMatches(shortName) {
        switch (shortName) {
            case 'ASAT':
                this.setState((prevState) => ({
                    showAsatNotMatchesActive: !prevState.showAsatNotMatchesActive
                }));
                break;
            case 'RES':
                this.setState((prevState) => ({
                    showResNotMatchesActive: !prevState.showResNotMatchesActive
                }));
                break;
            case 'CSAT':
                this.setState((prevState) => ({
                    showCsatNotMatchesActive: !prevState.showCsatNotMatchesActive
                }));
                break;
            case 'tNPS':
                this.setState((prevState) => ({
                    showNpsNotMatchesActive: !prevState.showNpsNotMatchesActive
                }));
                break;
            default:
        }
    }

    // Show hide filter functions
    showFiltersHeader() {
        this.setState({ showFiltersHeader: true });
    }

    hideFiltersHeader() {
        this.setState({
            showFiltersHeader: false,

            searchAgentNameQuery: undefined,

            showAsatMatchesActive: true,
            showAsatNotMatchesActive: true,
            showResMatchesActive: true,
            showResNotMatchesActive: true,
            showCsatMatchesActive: true,
            showCsatNotMatchesActive: true,
            showNpsMatchesActive: true,
            showNpsNotMatchesActive: true,
        });
    }
    ////DaysSinceLastJibeSession
    //showDaysSinceLastJibeSessionFilterPopup() {
    //    this.setState({
    //        showDaysSinceLastJibeSessionFilterPopup: true,
    //    });
    //}

    //hideDaysSinceLastJibeSessionFilterPopup(min, max) {
    //    this.setState({
    //        showDaysSinceLastJibeSessionFilterPopup: false,
    //        minDaysSinceLastJibeSessionFilterValue: min,
    //        maxDaysSinceLastJibeSessionFilterValue: max
    //    });
    //}

    //hideDaysSinceLastJibeSessionFiltersHeader() {
    //    this.setState({
    //        minDaysSinceLastJibeSessionFilterValue: undefined,
    //        maxDaysSinceLastJibeSessionFilterValue: undefined
    //    });
    //}

    ////////////////////////////////////////////////////

    onSearchAgent({ target }) {
        this.setState({ searchAgentNameQuery: target.value });
    }

    onSelectAgentFilter({ currentTarget }) {
        if (!currentTarget || !currentTarget.options || typeof currentTarget.options.selectedIndex === 'undefined'
            || !agentsFilters || !Array.isArray(agentsFilters))
            return;

        let selectedAgentFilter = agentsFilters[currentTarget.options.selectedIndex];
        this.setState({ selectedAgentFilter });
    }

    getSelectedFilterValuesNode(key, value, onClick) {
        return (
            <div className="selected-node" style={{ padding: '0 20px' }} key={key}>
                <HighlightOffIcon onClick={() => onClick(key)} style={{ margin: '0 10px 0 -5px', color: '#98DDE1' }} />
                {value}
            </div>);
    }

    getMinMaxFiltersHeader(minValue, maxValue, closeFunc) {
        let header;
        if (isDefined(maxValue) && maxValue !== '' &&
            isDefined(minValue) && minValue !== '') {
            header = this.getSelectedFilterValuesNode(1, `${minValue} to ${maxValue}`, closeFunc);
        }
        else if (isDefined(minValue) && minValue !== '') {
            header = this.getSelectedFilterValuesNode(1, `Min: ${minValue}`, closeFunc);
        }
        else if (isDefined(maxValue) && maxValue !== '') {
            header = this.getSelectedFilterValuesNode(1, `Max: ${maxValue}`, closeFunc);
        }
        return header;
    }

    getTableColumns() {
        const
            {
                calibratedOnSurveyQuestions,
            } = this.props;
        let nameHeader = 'Name';
        let lastJibeSessionHeader = 'Jibe Sessions Last 30 Days';

        if (this.state.showFiltersHeader) {
            nameHeader = (<ZSearch placeHolder="Search agent name" searchValue={this.state.searchAgentNameQuery}
                onChange={this.onSearchAgent} />)
            //lastJibeSessionHeader = (<div className="table-header-filter min-max-type"
            //    onClick={this.showDaysSinceLastJibeSessionFilterPopup}>Jibe Sessions Last 30 Days</div>);
        }

        const nameColumn = {
            Header: nameHeader,
            accessor: 'agentName',
            width: 274
        };

        const columns = [nameColumn];
        if (calibratedOnSurveyQuestions && Array.isArray(calibratedOnSurveyQuestions)) {
            calibratedOnSurveyQuestions.forEach(sq => {
                if (!this.state.showFiltersHeader) {
                    columns.push(
                        {
                            Header: sq.shortName,
                            accessor: sq.internalName
                        }
                    );
                }
                else {
                    let matchingIcon;
                    let notMatchingIcon;

                    switch (sq.shortName) {
                        case 'ASAT':
                            matchingIcon = this.state.showAsatMatchesActive ? <MatchingAnswersIcon /> : <MatchingAnswersIconNotActive />
                            notMatchingIcon = this.state.showAsatNotMatchesActive ? <NotMatchingAnswersIcon /> : <NotMatchingAnswersIconNotActive />;
                            break;
                        case 'RES':
                            matchingIcon = this.state.showResMatchesActive ? <MatchingAnswersIcon /> : <MatchingAnswersIconNotActive />
                            notMatchingIcon = this.state.showResNotMatchesActive ? <NotMatchingAnswersIcon /> : <NotMatchingAnswersIconNotActive />;
                            break;
                        case 'CSAT':
                            matchingIcon = this.state.showCsatMatchesActive ? <MatchingAnswersIcon /> : <MatchingAnswersIconNotActive />
                            notMatchingIcon = this.state.showCsatNotMatchesActive ? <NotMatchingAnswersIcon /> : <NotMatchingAnswersIconNotActive />;
                            break;
                        case 'tNPS':
                            matchingIcon = this.state.showNpsMatchesActive ? <MatchingAnswersIcon /> : <MatchingAnswersIconNotActive />
                            notMatchingIcon = this.state.showNpsNotMatchesActive ? <NotMatchingAnswersIcon /> : <NotMatchingAnswersIconNotActive />;
                            break;
                        default:
                    }

                    const matches = <div style={{ height: '33px', margin: '4px 0 0 6px' }} onClick={() => this.changeMatches(sq.shortName)} >
                        {matchingIcon}
                    </div>;
                    const notMatches = <div style={{ height: '33px', margin: '4px 0 0 2px' }} onClick={() => this.changeNotMatches(sq.shortName)} >
                        {notMatchingIcon}</div>;

                    columns.push(
                        {
                            Header: <div style={{ display: 'flex', justifyContent: 'center', height: '38px', marginTop: '4px' }}>
                                {sq.shortName} {matches}{notMatches}
                            </div>,
                            accessor: sq.internalName
                        }
                    );
                }
            });
        }

        columns.push(
            {
                Header: 'Customer Responses',
                accessor: 'surveyCnt',
                width: 230
            });

        columns.push(
            {
                Header: lastJibeSessionHeader,
                accessor: 'jibeSessionsPast30DaysCount',
                width: 230
            });
        columns.push(
            {
                Header: '',
                accessor: 'e',
                width: 60
            });

        return columns;
    }

    render() {
        const
            {
                currentTeamAgentsCalibrationStats,
                calibratedOnSurveyQuestions,
                onSelectAgent,
                hideTitle
            } = this.props;

        let result = {};
        result.columns = this.getTableColumns();

        const loading = !currentTeamAgentsCalibrationStats;
        if (loading === true) {
            return (<ReactTable
                columns={result.columns}
                defaultPageSize={10}
                loading={loading}
                className="-striped -highlight"
            />);
        }

        const teamsCalibrationStatsForOwnTeamCopy =
            currentTeamAgentsCalibrationStats && Array.isArray(currentTeamAgentsCalibrationStats)
                ? cloneArray(currentTeamAgentsCalibrationStats)
                : [];
        const agentCountLabel = teamsCalibrationStatsForOwnTeamCopy ? `(${teamsCalibrationStatsForOwnTeamCopy.length} Agents)` : '';

        result.data = (teamsCalibrationStatsForOwnTeamCopy && Array.isArray(teamsCalibrationStatsForOwnTeamCopy))
            ? teamsCalibrationStatsForOwnTeamCopy : [];

        //filter by pre-defined team filters
        if (isDefined(this.state.selectedAgentFilter) && this.state.selectedAgentFilter.filterName !== 'All') {
            if (this.state.selectedAgentFilter.filterName === 'Jibed') {
                result.data = result.data.filter(a => isJibedOnAllQuestions(a));
            }
            if (this.state.selectedAgentFilter.filterName === 'Not Jibed') {
                result.data = result.data.filter(a => !isJibedOnAllQuestions(a));
            }
        }

        //filter by agentName
        if (isDefined(this.state.searchAgentNameQuery) && this.state.searchAgentNameQuery !== '') {
            result.data = result.data.filter(a => a.agentName.toLowerCase().includes(this.state.searchAgentNameQuery.toLowerCase()));
        }

        //filter by days since lastJibeSession
        if (isDefined(this.state.minDaysSinceLastJibeSessionFilterValue) && this.state.minDaysSinceLastJibeSessionFilterValue !== '') {
            result.data = result.data.filter(a => moment(moment()).diff(a.lastJibeSession, 'days') >= this.state.minDaysSinceLastJibeSessionFilterValue);
        }
        if (isDefined(this.state.maxDaysSinceLastJibeSessionFilterValue) && this.state.maxDaysSinceLastJibeSessionFilterValue !== '') {
            result.data = result.data.filter(a => moment(moment()).diff(a.lastJibeSession, 'days') <= this.state.maxDaysSinceLastJibeSessionFilterValue);
        }

        ////DaysSinceLastJibeSession
        //const daysSinceLastJibeSessionFiltersHeader =
        //    this.getMinMaxFiltersHeader(this.state.minDaysSinceLastJibeSessionFilterValue,
        //        this.state.maxDaysSinceLastJibeSessionFilterValue, this.hideDaysSinceLastJibeSessionFiltersHeader);
        //if (daysSinceLastJibeSessionFiltersHeader) {
        //    let col = result.columns.find(c => c.accessor === columnsAccessors.lastJibeSession);
        //    if (col) {
        //        col.Header = daysSinceLastJibeSessionFiltersHeader;
        //    }
        //}

        //Filter by answer match/not match for each question
        //Asat
        if (isDefined(this.state.showAsatMatchesActive)) {
            if (this.state.showAsatMatchesActive) {

            }
            else {
                result.data = result.data.filter(a => a.representativeSatisfactionCalibrationStatusId === CalibrationStatus.NotJibed);
            }
        }
        if (isDefined(this.state.showAsatNotMatchesActive)) {
            if (this.state.showAsatNotMatchesActive) {

            }
            else {
                result.data = result.data.filter(a => a.representativeSatisfactionCalibrationStatusId === CalibrationStatus.Jibed);
            }
        }
        //Res
        if (isDefined(this.state.showResMatchesActive)) {
            if (this.state.showResMatchesActive) {

            }
            else {
                result.data = result.data.filter(a => a.resolutionCalibrationStatusId === CalibrationStatus.NotJibed);
            }
        }
        if (isDefined(this.state.showResNotMatchesActive)) {
            if (this.state.showResNotMatchesActive) {

            }
            else {
                result.data = result.data.filter(a => a.resolutionCalibrationStatusId === CalibrationStatus.Jibed);
            }
        }

        //Csat
        if (isDefined(this.state.showCsatMatchesActive)) {
            if (this.state.showCsatMatchesActive) {

            }
            else {
                result.data = result.data.filter(a => a.customerSatisfactionCalibrationStatusId === CalibrationStatus.NotJibed);
            }
        }
        if (isDefined(this.state.showCsatNotMatchesActive)) {
            if (this.state.showCsatNotMatchesActive) {

            }
            else {
                result.data = result.data.filter(a => a.customerSatisfactionCalibrationStatusId === CalibrationStatus.Jibed);
            }
        }

        //Nps
        if (isDefined(this.state.showNpsMatchesActive)) {
            if (this.state.showNpsMatchesActive) {

            }
            else {
                result.data = result.data.filter(a => a.netPromoterScoreCalibrationStatusId === CalibrationStatus.NotJibed);
            }
        }
        if (isDefined(this.state.showNpsNotMatchesActive)) {
            if (this.state.showNpsNotMatchesActive) {

            }
            else {
                result.data = result.data.filter(a => a.netPromoterScoreCalibrationStatusId === CalibrationStatus.Jibed);
            }
        }

        if (isDefined(this.state.selectedReasonForContact)) {
            result.data = result.data.filter(a => a.reasonForContact === this.state.selectedReasonForContact.value);
        }

        //form table body by adding icons and styling
        if (result.data && Array.isArray(result.data)) {
            result.data.forEach(row => {
                if (isDefined(row.agentName)) {
                    const firstLetter = row.agentName.charAt(0).toUpperCase();
                    const avatarBackground = 'linear-gradient(91.89deg, #98DDE1 -6.8%, #C0EAED 100.34%)';
                    row.agentName = <div style={{ textAlign: 'start' }}>
                        <div style={{
                            background: avatarBackground,
                            borderRadius: '4px',
                            display: 'inline-block',
                            width: '32px',
                            color: 'white',
                            marginRight: '10px',
                            fontWeight: 'bold',
                            textAlign: 'center',
                            fontSize: '20px',
                            display: 'inline-block',
                            verticalAlign: 'middle',
                            padding: '3px'
                        }}>
                            {firstLetter}
                        </div>
                        {row.agentName}
                    </div>;
                }

                if (isDefined(row.lastJibeSession)) {
                    row.lastJibeSession = moment(moment()).diff(row.lastJibeSession, 'days');
                }

                if (calibratedOnSurveyQuestions && Array.isArray(calibratedOnSurveyQuestions)) {
                    calibratedOnSurveyQuestions.forEach(sq => {
                        let sqCalibrationScore = row[`${sq.internalName}CalibrationScore`];
                        const sqCalibrationStatusId = row[`${sq.internalName}CalibrationStatusId`];
                        const avatarStyle = sqCalibrationStatusId === CalibrationStatus.Jibed ? "percentage-green-avatar" : "percentage-red-avatar";

                        row[sq.internalName] = (<div className={avatarStyle}>
                            {sqCalibrationScore}
                        </div>);

                    });
                }
            });
        }

        const agentsResultTable = (<ReactTable
            data={result.data}
            columns={result.columns}
            defaultPageSize={10}
            loading={loading}
            className="-striped -highlight"
            getTrProps={(state, rowInfo) => {
                if (rowInfo && rowInfo.row && rowInfo.original) {
                    return {
                        onClick: () => {
                            onSelectAgent(rowInfo.original.agentId)
                        }
                    };
                } else {
                    return {};
                }
            }}
            defaultSortMethod={sortReactTable}
        />);

        let agentsFiltersNode;
        if (agentsFilters && Array.isArray(agentsFilters)) {
            const options = agentsFilters.map(t => (<option value={t.filterName} key={t.filterName}>{t.filterName}</option>));
            const length = options.length;
            agentsFiltersNode = (<div className="vertical-select">
                <select size={length} onChange={this.onSelectAgentFilter} defaultValue={'All'}>
                    {options}
                </select>
            </div>)
        }

        return (<div>
            {!hideTitle &&
                <div className="teams-table-for-manager filters-wrapper">

                    <div className="teams-table-for-manager filter-area-title-wrapper">
                        <label className="teams-table-for-manager all-teams-title">All Agents</label>
                        <label className="teams-table-for-manager number-of-teams-title">{agentCountLabel}</label>
                    </div>

                    <div className="teams-table-for-manager teams-filter-names-wrapper">
                        {agentsFiltersNode}
                    </div>
                </div>
            }
            <div style={{ position: 'relative', zIndex: 0, fontSize: '14px' }}>
                {!this.state.showFiltersHeader &&
                    <div onClick={this.showFiltersHeader} style={{
                        position: 'absolute',
                        zIndex: 2,
                        right: '0',
                        cursor: 'pointer'
                    }}>
                        <FilterIconBack />
                    </div>}
                {!this.state.showFiltersHeader &&
                    <div onClick={this.showFiltersHeader} style={{
                        position: 'absolute',
                        zIndex: 3,
                        right: '0',
                        cursor: 'pointer'
                    }}>
                        <FilterIcon />
                    </div>}

                {this.state.showFiltersHeader &&
                    <div onClick={this.hideFiltersHeader} style={{
                        position: 'absolute',
                        zIndex: 2,
                        right: '9px',
                        top: '9px',
                        cursor: 'pointer'
                    }}>
                        <CloseFilterIcon />
                    </div>}
                {agentsResultTable}
                {/*
                {this.state.showDaysSinceLastJibeSessionFilterPopup &&
                    (<MinMaxSelectorFilter
                        title="Jibe Sessions Last 30 Days"
                        onClose={this.hideDaysSinceLastJibeSessionFilterPopup} />)}
                */ }
            </div>
        </div>);
    };
}

const select = state => ({ ...state.CalibrationV3Screen });
export default connect(select)(AgentsTableForSupervisor);
